/**
 * Pomodoro Timer - Focus Timer for Productivity
 * Free online Pomodoro timer with customizable work and break intervals
 */
(function() {
    'use strict';

    // Settings
    let settings = {
        work: 25,
        shortBreak: 5,
        longBreak: 15,
        sessionsUntilLong: 4,
        soundEnabled: true,
        autoStart: false
    };

    // State
    let currentMode = 'work';
    let timeRemaining = settings.work * 60;
    let timerInterval = null;
    let isRunning = false;
    let currentSession = 1;
    let completedSessions = 0;
    let totalFocusTime = 0;
    let streak = 0;

    // Elements
    const display = document.getElementById('timer-display');
    const label = document.getElementById('timer-label');
    const btnStart = document.getElementById('btn-start');
    const btnPause = document.getElementById('btn-pause');
    const btnReset = document.getElementById('btn-reset');
    const btnSkip = document.getElementById('btn-skip');
    const btnSettings = document.getElementById('btn-settings');
    const settingsPanel = document.getElementById('settings-panel');
    const sessionCount = document.getElementById('session-count');
    const sessionDots = document.getElementById('session-dots');
    const pomodoroCard = document.getElementById('pomodoro-card');

    // Audio
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();

    /**
     * Play completion sound with three beeps
     */
    function playSound() {
        if (!settings.soundEnabled) return;
        
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();
        
        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);
        
        oscillator.frequency.value = 800;
        oscillator.type = 'sine';
        
        gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
        
        oscillator.start(audioContext.currentTime);
        oscillator.stop(audioContext.currentTime + 0.5);

        // Play 3 beeps
        setTimeout(function() {
            const osc2 = audioContext.createOscillator();
            const gain2 = audioContext.createGain();
            osc2.connect(gain2);
            gain2.connect(audioContext.destination);
            osc2.frequency.value = 800;
            gain2.gain.setValueAtTime(0.3, audioContext.currentTime);
            gain2.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
            osc2.start(audioContext.currentTime);
            osc2.stop(audioContext.currentTime + 0.5);
        }, 600);

        setTimeout(function() {
            const osc3 = audioContext.createOscillator();
            const gain3 = audioContext.createGain();
            osc3.connect(gain3);
            gain3.connect(audioContext.destination);
            osc3.frequency.value = 1000;
            gain3.gain.setValueAtTime(0.3, audioContext.currentTime);
            gain3.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.8);
            osc3.start(audioContext.currentTime);
            osc3.stop(audioContext.currentTime + 0.8);
        }, 1200);
    }

    /**
     * Format seconds into MM:SS format
     * @param {number} seconds - Total seconds
     * @returns {string} Formatted time string
     */
    function formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return mins.toString().padStart(2, '0') + ':' + secs.toString().padStart(2, '0');
    }

    /**
     * Update timer display and document title
     */
    function updateDisplay() {
        display.textContent = formatTime(timeRemaining);
        document.title = formatTime(timeRemaining) + ' - ' + getModeLabel(currentMode) + ' | Pomodoro Timer';
    }

    /**
     * Get display label for current mode
     * @param {string} mode - Current timer mode
     * @returns {string} Display label
     */
    function getModeLabel(mode) {
        switch(mode) {
            case 'work': return 'Focus Time';
            case 'shortBreak': return 'Short Break';
            case 'longBreak': return 'Long Break';
            default: return 'Pomodoro';
        }
    }

    /**
     * Set timer mode and update UI
     * @param {string} mode - Mode to set (work, shortBreak, longBreak)
     */
    function setMode(mode) {
        currentMode = mode;
        
        switch(mode) {
            case 'work':
                timeRemaining = settings.work * 60;
                pomodoroCard.className = 'pomodoro-card mode-work';
                break;
            case 'shortBreak':
                timeRemaining = settings.shortBreak * 60;
                pomodoroCard.className = 'pomodoro-card mode-short-break';
                break;
            case 'longBreak':
                timeRemaining = settings.longBreak * 60;
                pomodoroCard.className = 'pomodoro-card mode-long-break';
                break;
        }
        
        label.textContent = getModeLabel(mode);
        updateDisplay();
        updateModeTabs();
    }

    /**
     * Update active mode tab styling
     */
    function updateModeTabs() {
        document.querySelectorAll('.mode-tab').forEach(function(tab) {
            tab.classList.toggle('active', tab.dataset.mode === currentMode);
        });
    }

    /**
     * Update session dots visual indicator
     */
    function updateSessionDots() {
        sessionDots.innerHTML = '';
        for (let i = 0; i < settings.sessionsUntilLong; i++) {
            const dot = document.createElement('span');
            dot.className = 'session-dot';
            if (i < currentSession) dot.classList.add('active');
            if (i < currentSession - 1) dot.classList.add('completed');
            sessionDots.appendChild(dot);
        }
        sessionCount.textContent = 'Session ' + currentSession + ' of ' + settings.sessionsUntilLong;
    }

    /**
     * Update statistics display
     */
    function updateStats() {
        document.getElementById('stat-completed').textContent = completedSessions;
        document.getElementById('stat-time').textContent = totalFocusTime >= 60 
            ? Math.floor(totalFocusTime / 60) + 'h ' + (totalFocusTime % 60) + 'm' 
            : totalFocusTime + 'm';
        document.getElementById('stat-streak').textContent = streak;
    }

    /**
     * Start the timer
     */
    function start() {
        if (isRunning) return;
        
        // Resume audio context if suspended
        if (audioContext.state === 'suspended') {
            audioContext.resume();
        }
        
        isRunning = true;
        btnStart.classList.add('d-none');
        btnPause.classList.remove('d-none');

        timerInterval = setInterval(function() {
            timeRemaining--;
            updateDisplay();

            if (timeRemaining <= 0) {
                timerComplete();
            }
        }, 1000);
    }

    /**
     * Pause the timer
     */
    function pause() {
        if (!isRunning) return;
        
        isRunning = false;
        clearInterval(timerInterval);
        btnStart.classList.remove('d-none');
        btnPause.classList.add('d-none');
    }

    /**
     * Reset timer to current mode's default duration
     */
    function reset() {
        pause();
        setMode(currentMode);
    }

    /**
     * Skip to next timer phase
     */
    function skip() {
        pause();
        timerComplete();
    }

    /**
     * Handle timer completion
     */
    function timerComplete() {
        pause();
        playSound();

        if (currentMode === 'work') {
            completedSessions++;
            totalFocusTime += settings.work;
            streak++;
            
            if (currentSession >= settings.sessionsUntilLong) {
                currentSession = 1;
                setMode('longBreak');
            } else {
                currentSession++;
                setMode('shortBreak');
            }
        } else {
            setMode('work');
        }

        updateSessionDots();
        updateStats();

        if (settings.autoStart) {
            setTimeout(start, 1000);
        }
    }

    // Event Listeners
    btnStart.addEventListener('click', start);
    btnPause.addEventListener('click', pause);
    btnReset.addEventListener('click', reset);
    btnSkip.addEventListener('click', skip);

    btnSettings.addEventListener('click', function() {
        settingsPanel.classList.toggle('d-none');
    });

    document.getElementById('btn-save-settings').addEventListener('click', function() {
        settings.work = parseInt(document.getElementById('setting-work').value) || 25;
        settings.shortBreak = parseInt(document.getElementById('setting-short').value) || 5;
        settings.longBreak = parseInt(document.getElementById('setting-long').value) || 15;
        settings.sessionsUntilLong = parseInt(document.getElementById('setting-sessions').value) || 4;
        settings.soundEnabled = document.getElementById('setting-sound').checked;
        settings.autoStart = document.getElementById('setting-auto').checked;

        localStorage.setItem('pomodoro-settings', JSON.stringify(settings));
        
        if (!isRunning) {
            setMode(currentMode);
        }
        updateSessionDots();
        settingsPanel.classList.add('d-none');
    });

    /** @type {HTMLElement|null} */
    let pendingModeTab = null;
    const modeSwitchModal = document.getElementById('modeSwitchModal');
    const modeSwitchModalInstance = modeSwitchModal ? new bootstrap.Modal(modeSwitchModal) : null;
    const confirmModeSwitchBtn = document.getElementById('confirmModeSwitchBtn');

    if (confirmModeSwitchBtn) {
        confirmModeSwitchBtn.addEventListener('click', function() {
            if (modeSwitchModalInstance) {
                modeSwitchModalInstance.hide();
            }
            if (pendingModeTab) {
                pause();
                setMode(pendingModeTab.dataset.mode);
                pendingModeTab = null;
            }
        });
    }

    document.querySelectorAll('.mode-tab').forEach(function(tab) {
        tab.addEventListener('click', function() {
            if (isRunning) {
                pendingModeTab = tab;
                if (modeSwitchModalInstance) {
                    modeSwitchModalInstance.show();
                }
                return;
            }
            setMode(tab.dataset.mode);
        });
    });

    // Keyboard shortcuts
    document.addEventListener('keydown', function(e) {
        if (e.target.tagName === 'INPUT') return;
        
        if (e.code === 'Space') {
            e.preventDefault();
            isRunning ? pause() : start();
        } else if (e.key.toLowerCase() === 'r') {
            reset();
        } else if (e.key.toLowerCase() === 's') {
            skip();
        }
    });

    // Load saved settings
    const savedSettings = localStorage.getItem('pomodoro-settings');
    if (savedSettings) {
        settings = Object.assign({}, settings, JSON.parse(savedSettings));
        document.getElementById('setting-work').value = settings.work;
        document.getElementById('setting-short').value = settings.shortBreak;
        document.getElementById('setting-long').value = settings.longBreak;
        document.getElementById('setting-sessions').value = settings.sessionsUntilLong;
        document.getElementById('setting-sound').checked = settings.soundEnabled;
        document.getElementById('setting-auto').checked = settings.autoStart;
    }

    // Initialize
    setMode('work');
    updateSessionDots();
    updateStats();
})();
